type Category = 'packaging';

type CategoryPageConfig = Record<Category, { path: string; availableLocales: string[] }>;

export const categoryPageConfig: CategoryPageConfig = {
    packaging: {
        path: '/design/packaging',
        availableLocales: ['en-US', 'es-US', 'en-CA', 'fr-CA'],
    },
};
